import i18next from 'i18next';
import * as loglevel from 'loglevel';
var WMLog = (function () {
    function WMLog() {
    }
    WMLog.prototype.init = function (options, level) {
        if (level === void 0) { level = 'silent'; }
        i18next.init(options, function () { });
        loglevel.setLevel(level);
    };
    WMLog.prototype.trace = function () {
        loglevel.trace();
    };
    WMLog.prototype.debug = function (message, args) {
        loglevel.debug(this.getLocalizedMessage(message, args));
    };
    WMLog.prototype.info = function (message, args) {
        loglevel.info(this.getLocalizedMessage(message, args));
    };
    WMLog.prototype.warn = function (message, args) {
        loglevel.warn(this.getLocalizedMessage(message, args));
    };
    WMLog.prototype.error = function (message, args) {
        loglevel.error(this.getLocalizedMessage(message, args));
    };
    WMLog.prototype.getLocalizedMessage = function (msg, args) {
        var tag = localStorage.getItem('logTag');
        if (tag) {
            msg = '[' + tag + '] ' + msg;
        }
        if (msg && isI18nMessage(msg)) {
            if (args) {
                return i18next.t(msg, args);
            }
            return i18next.t(msg);
        }
        return msg;
    };
    return WMLog;
}());
export { WMLog };
var WMLogger = (function () {
    function WMLogger(inject) {
        WMLogger.instance();
    }
    WMLogger.instance = function () {
        if (WMLogger.Log === undefined || WMLogger.Log === null) {
            WMLogger.Log = new WMLog();
        }
        return WMLogger.Log;
    };
    return WMLogger;
}());
export { WMLogger };
function isI18nMessage(msg) {
    msg = msg.toString();
    return msg.indexOf('error.') === 0 ||
        msg.indexOf('warn.') === 0 ||
        msg.indexOf('debug.') === 0 ||
        msg.indexOf('info.') === 0;
}
window.loglevel = function (level) {
    loglevel.setLevel(level);
};
